import { useRegisterSW } from 'virtual:pwa-register/react'
import { RefreshCw, X } from 'lucide-react'

export default function ReloadPrompt() {
    const {
        offlineReady: [offlineReady, setOfflineReady],
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(r: ServiceWorkerRegistration | undefined) {
            console.log('SW Registered: ' + r)
        },
        onRegisterError(error: any) {
            console.log('SW registration error', error)
        },
    })

    const close = () => {
        setOfflineReady(false)
        setNeedRefresh(false)
    }

    // Banner PWA desabilitado - retorna null sempre
    return null

    // Código original comentado para referência futura
    /*
    if (!offlineReady && !needRefresh) return null

    return (
        <div className="fixed bottom-0 right-0 p-6 z-50 animate-in slide-in-from-bottom duration-500">
            <div className="bg-primary/95 backdrop-blur-md text-white p-6 rounded-2xl shadow-2xl flex flex-col gap-4 border border-white/10 max-w-sm">
                <div className="flex items-start justify-between">
                    <div>
                        <h3 className="text-sm font-black uppercase tracking-widest mb-1">
                            {offlineReady ? 'Aplicativo Pronto' : 'Nova Versão Disponível'}
                        </h3>
                        <p className="text-xs text-white/70">
                            {offlineReady
                                ? 'App pronto para uso offline.'
                                : 'Clique no botão abaixo para atualizar.'}
                        </p>
                    </div>
                    <button onClick={close} className="text-white/50 hover:text-white transition-colors">
                        <X className="w-5 h-5" />
                    </button>
                </div>

                {needRefresh && (
                    <button
                        onClick={() => updateServiceWorker(true)}
                        className="flex items-center justify-center gap-2 w-full py-3 bg-secondary text-white rounded-xl text-xs font-black uppercase tracking-widest hover:bg-secondary/80 transition-all shadow-lg shadow-secondary/20"
                    >
                        <RefreshCw className="w-4 h-4" />
                        Atualizar Agora
                    </button>
                )}
            </div>
        </div>
    )
    */
}
